import { RedoButton } from "@redotech/arbiter/buttons/redo-button";
import { useTranslation } from "@redotech/redo-i18n";
import { memo, useCallback, useState } from "react";
import { getDashboardUrl } from "../../core/auth";
import { useAuth } from "../../core/auth-provider";
import { FeedbackModal } from "./feedback-modal";

export const ExitOnboardingButton = memo(function ExitOnboardingButton({
  className,
  renderAsArbiterButton = false,
  skipPrompt = false,
  text,
  textClassName,
}: {
  className?: string;
  renderAsArbiterButton?: boolean;
  skipPrompt?: boolean;
  text?: string;
  textClassName?: string;
}) {
  const { t } = useTranslation();
  const label = text ?? t("Exit to Dashboard");
  const auth = useAuth();
  const href = getDashboardUrl(auth?.token);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleButtonClick = useCallback(() => {
    if (skipPrompt) {
      window.location.href = href;
      return;
    }
    setIsModalOpen(true);
  }, [href, skipPrompt]);

  const handleClose = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const handleConfirm = useCallback(() => {
    window.location.href = href;
  }, [href]);

  return (
    <>
      {renderAsArbiterButton ? (
        <RedoButton
          hierarchy="secondary"
          onClick={handleButtonClick}
          size="sm"
          text={label}
        />
      ) : (
        // design-allow: Product onboarding retains its existing styled control outside this landing-page change.
        <button className={className} onClick={handleButtonClick} type="button">
          <span className={textClassName}>{label}</span>
        </button>
      )}
      {!skipPrompt && (
        <FeedbackModal
          isOpen={isModalOpen}
          onClose={handleClose}
          onConfirm={handleConfirm}
        />
      )}
    </>
  );
});
